module.exports = __webpack_public_path__ + "img/16.f646e653.png";